import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IndicateurModel, DiagnosticModel } from '../../main/Models';
import { ApiService } from '../../custom-material/Services/';
import { globalData } from 'src/app/main/Models/global.model';

@Component({
  selector: 'audit-questionnary-indicator',
  templateUrl: './t_indicator.component.html',
  styleUrls: ['./indicator.component.less']
})
export class IndicatorComponent implements OnInit {

  @Input('indicator') indicator:IndicateurModel;
  @Input('diagnostic') diagnostic: DiagnosticModel;

  @Output('change') change:EventEmitter<IndicateurModel> = new EventEmitter();


  constructor(
    private apiService: ApiService,
    public gd: globalData) { }

  ngOnInit() {
    console.log('diagnostic', this.diagnostic);
   }

  /**
  * view helper to know if the answer of an indicator is active or not
  */
  isAnswerActive()
  {
    if(this.indicator==undefined) return false; //indicator n'existe pas (pour eviter bugs)
    if(this.indicator.answer==undefined
    || this.indicator.answer.active==undefined) return false; //answer n'existe pas (pour eviter bugs)

    if(this.indicator.multichoicegravity==-10) return false; // mode sans scoring
    return this.indicator.answer.active;
  }

  setChanged()
  {
    this.pushToRight();
    this.change.emit(this.indicator);
  }

  /**
  * push pictures container scroll to the right
  */
   pushToRight()
   {
     let element = document.getElementById('pics-'+this.indicator.id);
     if(element==null) return;
     setTimeout(()=>{
       let scrollX = this.indicator.answer.freephoto.length * 200;
       element.scroll(element.clientWidth, 0);
     }, 100);

   }
}
